export default "__VITE_ASSET__DfzXDO$K__"